import { typography } from './typography'

export const textStyles = {
  '.text-heading-xlarge': {
    fontFamily: 'var(--font-sans)',
    fontSize: typography.fontSize['3xl'],
    lineHeight: typography.lineHeight['3xl'],
    fontWeight: typography.fontWeight.bold,
  },
  '.text-heading-large': {
    fontFamily: 'var(--font-sans)',
    fontSize: typography.fontSize['2xl'],
    lineHeight: typography.lineHeight['2xl'],
    fontWeight: typography.fontWeight.bold,
  },
  '.text-heading-medium': {
    fontFamily: 'var(--font-sans)',
    fontSize: typography.fontSize.xl,
    lineHeight: typography.lineHeight.xl,
    fontWeight: typography.fontWeight.bold,
  },
  '.text-heading-small': {
    fontFamily: 'var(--font-sans)',
    fontSize: typography.fontSize.lg,
    lineHeight: typography.lineHeight.lg,
    fontWeight: typography.fontWeight.bold,
  },
  '.text-heading-xsmall': {
    fontFamily: 'var(--font-sans)',
    fontSize: typography.fontSize.base,
    lineHeight: typography.lineHeight.base,
    fontWeight: typography.fontWeight.bold,
  },
  '.text-heading-xxsmall': {
    fontFamily: 'var(--font-sans)',
    fontSize: typography.fontSize.sm,
    lineHeight: typography.lineHeight.sm,
    fontWeight: typography.fontWeight.bold,
  },
  '.text-body-large': {
    fontFamily: 'var(--font-sans)',
    fontSize: typography.fontSize.base,
    lineHeight: typography.lineHeight.base,
    fontWeight: typography.fontWeight.normal,
  },
  '.text-body-default': {
    fontFamily: 'var(--font-sans)',
    fontSize: typography.fontSize.sm,
    lineHeight: typography.lineHeight.sm,
    fontWeight: typography.fontWeight.normal,
  },
  '.text-body-small': {
    fontFamily: 'var(--font-sans)',
    fontSize: typography.fontSize.xs,
    lineHeight: typography.lineHeight.xs,
    fontWeight: typography.fontWeight.normal,
  },
  '.text-label-large': {
    fontFamily: 'var(--font-sans)',
    fontSize: typography.fontSize.base,
    lineHeight: typography.lineHeight.base,
    fontWeight: typography.fontWeight.medium,
  },
  '.text-label-default': {
    fontFamily: 'var(--font-sans)',
    fontSize: typography.fontSize.sm,
    lineHeight: typography.lineHeight.sm,
    fontWeight: typography.fontWeight.medium,
  },
  '.text-label-small': {
    fontFamily: 'var(--font-sans)',
    fontSize: typography.fontSize.xs,
    lineHeight: typography.lineHeight.xs,
    fontWeight: typography.fontWeight.medium,
  },
  '.text-label-overline': {
    fontFamily: 'var(--font-sans)',
    fontSize: typography.fontSize.xs,
    lineHeight: typography.lineHeight.xs,
    fontWeight: typography.fontWeight.bold,
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
  },
} as const
